function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "4em",
    width: "4em",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A75C3"
    },
    d: "M256,0C114.616,0,0.001,114.615,0.001,255.999c0,50.147,14.421,96.924,39.339,136.413 l472.599-141.118C509.429,112.083,395.812,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F5AA8"
    },
    d: "M511.999,255.999c0-1.573-0.031-3.138-0.06-4.705L320.93,60.286l-129.862,180.45l88.123,88.123 L129.468,478.582C166.791,499.844,209.975,511.999,256,512C397.385,511.999,511.999,397.385,511.999,255.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6FAEE8"
    },
    d: "M437.129,205.913c-11.951-11.951-31.337-11.951-43.287,0l-125.03,125.031l30.618,55.956l137.7-137.7 C449.079,237.249,449.079,217.863,437.129,205.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCDEF7"
    },
    d: "M472.932,241.717c-11.951-11.951-31.335-11.951-43.287,0L328.564,342.798l-134.692-13.842 L63.8,367.955l-24.451,24.451c22.466,35.607,53.458,65.29,90.121,86.176l23.414-23.414l163.217-30.874 c12.013-2.365,28.925-11.384,37.582-20.041l119.25-119.25C484.884,273.052,484.884,253.667,472.932,241.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD652"
    },
    d: "M347.825,125.217c0,50.716-41.11,91.826-91.826,91.826l-64.278-91.826l64.278-91.826 C306.715,33.391,347.825,74.501,347.825,125.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBE287"
    },
    d: "M164.173,125.217c0,50.716,41.11,91.826,91.826,91.826V33.391 C205.284,33.391,164.173,74.501,164.173,125.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7EDBC"
    },
    d: "M255.999,194.108l-43.479-69.565l43.479-69.565c38.359,0,69.565,31.206,69.565,69.565 S294.358,194.108,255.999,194.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.434,124.543c0,38.359,31.206,69.565,69.565,69.565V54.978 C217.641,54.978,186.434,86.184,186.434,124.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBA4C"
    },
    d: "M347.826,175.804c0,50.716-41.11,91.826-91.826,91.826l-64.278-91.826L256,83.978 C306.716,83.978,347.826,125.088,347.826,175.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD652"
    },
    d: "M164.174,175.804c0,50.716,41.11,91.826,91.826,91.826V83.978 C205.285,83.978,164.174,125.088,164.174,175.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBE287"
    },
    d: "M256,244.694l-43.479-69.565L256,105.564c38.359,0,69.565,31.206,69.565,69.565 S294.359,244.694,256,244.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7EDBC"
    },
    d: "M186.435,175.129c0,38.359,31.206,69.565,69.565,69.565v-139.13 C217.642,105.564,186.435,136.77,186.435,175.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.333,289.987l-131.918-0.096c-18.918,0-38.385,4.833-52.862,19.309L63.8,367.955 c31.296,31.297,82.038,31.297,113.333,0l16.739-16.739c-0.003-0.011,113.461-0.012,113.461-0.012 c16.9,0,30.609-13.707,30.609-30.609C337.942,303.694,324.234,289.987,307.333,289.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCDEF7"
    },
    d: "M307.731,301.117H282.29l6.36,19.478l-6.36,19.478h25.452c10.51,0,19.07-8.737,19.07-19.478 S318.252,301.117,307.731,301.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDEFFB"
    },
    d: "M282.29,301.117l0.011,38.956c10.73,0,19.467-8.737,19.467-19.478S293.031,301.117,282.29,301.117z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashDollar);
export default __webpack_public_path__ + "static/media/cash-dollar.759a444f5308f0f2058110bf6ba37f88.svg";
export { ForwardRef as ReactComponent };